import Header from "components/common/header"

function Insight (){

    return (
        <div className="wrapper">
           <Header />
           <main>
                <h1>
                    This is Insight Page
                </h1>
           </main>
        </div>
    )
}

export default Insight